export const snippetsFilter = (
  searchState,
  flaggedState,
  starredState,
  bookmarkColorState,
  folderState,
  typeState,
  typeToggleButtonsLinks,
  swapSnippets
) => {
  if (searchState !== "") {
    swapSnippets = swapSnippets.filter(
      (snippet) =>
        snippet.title?.toLowerCase().includes(searchState?.toLowerCase()) ||
        snippet.body?.toLowerCase().includes(searchState?.toLowerCase()) ||
        snippet.createdAt.includes(searchState)
    );
  }

  if (bookmarkColorState) {
    swapSnippets = swapSnippets.filter(
      (snippet) => snippet.bookmarkColor === bookmarkColorState
    );
  }

  if (folderState) {
    swapSnippets = swapSnippets.filter(
      (snippet) => snippet.folder?.title === folderState
    );
  }

  if (folderState === null) {
    swapSnippets = swapSnippets.filter((snippet) => snippet.folder === null);
  }

  if (typeState === null) {
    swapSnippets = swapSnippets.filter((snippet) => snippet.type === null);
  }

  typeToggleButtonsLinks.find((type) => {
    if (type.title === typeState) {
      swapSnippets = swapSnippets.filter(
        (snippet) => snippet.type === type.title
      );
    }
  });

  if (flaggedState === "flagged") {
    swapSnippets = swapSnippets.filter((snippet) => snippet.flagged);
  }
  if (flaggedState === "not") {
    swapSnippets = swapSnippets.filter((snippet) => !snippet.flagged);
  }

  if (starredState === "starred") {
    swapSnippets = swapSnippets.filter((snippet) => snippet.starred);
  }
  if (starredState === "not") {
    swapSnippets = swapSnippets.filter((snippet) => !snippet.starred);
  }

  return swapSnippets;
};
